import { AxiosError } from 'axios'

import { ServerValidationError } from '@/api/shared/types'
import { isServerValidationError } from '@/utils/parseServerErrorField'

const AUTO_FORM_FIELDS = ['number', 'model', 'description', 'emoji'] as const

export type AutoServerErrorField = (typeof AUTO_FORM_FIELDS)[number]

export const parseAutoServerErrorField = (
  field?: string
): AutoServerErrorField | null => {
  const normalized = field?.replace(/^\//, '')

  return AUTO_FORM_FIELDS.includes(normalized as AutoServerErrorField)
    ? (normalized as AutoServerErrorField)
    : null
}

export const hasAutoFormServerErrors = (
  error?: AxiosError<ServerValidationError> | null
) => {
  if (!isServerValidationError(error)) {
    return false
  }

  return Boolean(
    error?.response?.data.errors?.some(({ field }) =>
      Boolean(parseAutoServerErrorField(field))
    )
  )
}
